export const mockTripByNumber = {
  default: {
    tripNumber: 2940391,
    bookingNumber: "39485743",
    carrier: { name: "C R ENGLAND INC" },
    dotNumber: "DOT-458-4783",
    mcNumber: "MC-192837",
    originSicCode: "ONT",
    destinationSicCode: "EWR",
  },
};
